import { useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { isTokenExpired } from '../../utils/authSession';

function ProtectedRoute() {
  const location = useLocation();
  const { authReady, isLoadingAuth, logout, token } = useAuth();
  const isExpired = Boolean(token && isTokenExpired(token));

  useEffect(() => {
    if (authReady && isExpired) {
      logout();
    }
  }, [authReady, isExpired, logout]);

  if (!authReady || (token && isLoadingAuth)) {
    return <div className="text-center py-5">Loading...</div>;
  }

  if (!token || isExpired) {
    if (location.pathname === '/login') {
      return <Outlet />;
    }

    return <Navigate to="/login" replace state={{ from: location, sessionExpired: isExpired || undefined }} />;
  }

  return <Outlet />;
}

export default ProtectedRoute;
